module.exports = __webpack_public_path__ + "img/icon_upside_potential.9c899ccf.svg";